import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {RangeHeaderComponent} from "@irb-common/components/grid/renderers/range.header.component";
import {RangeCellComponent} from "@irb-common/components/grid/renderers/range.cell.component";
import {ComPrAllocationsLegacyComponent} from "@irb/irb-editors/editor-portfolio-result/com-pr-allocations-legacy/com-pr-allocations-legacy.component";
import {PrAllocationsService, PrApplicationService} from "@irb/irb-editors/editor-portfolio-result/services";
import {CallToActionCellComponent} from '@irb-common/components/grid/renderers/calltoaction.cell.component';
import {IPortfolioResultModelHistory} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";

import {
    ColDef,
    ICellRendererParams,
    //ValueFormatterParams,
    ValueGetterParams,
    IAggFuncParams
} from 'ag-grid-community';

@Injectable({
    providedIn: "root"
})
export class ComPrAllocationsGridLayoutService implements GridLayoutService<ComPrAllocationsLegacyComponent> {

    constructor(private pralloc: PrAllocationsService, private pras: PrApplicationService) {
    }

    getFrameworkComponents() {
        return {
            "RangeHeaderComponent": RangeHeaderComponent,
            "RangeCellComponent": RangeCellComponent,
            "CallToActionCellComponent": CallToActionCellComponent
        };
    }

    getAggFuncs(parent: ComPrAllocationsLegacyComponent) {
        return {
            'secRelVariance': (params: IAggFuncParams): number => {
                if(params && params.values){
                const totalVariance = params.values.map((value: any) => value.secAbsVariance)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const totalTarget = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return totalVariance ? totalTarget ? (totalVariance * 100) / totalTarget : 100 : 0;
                }
            },
            'secRelVarianceAfterAdj': (params: IAggFuncParams): number => {
                if(params && params.values){
                const totaVariance = params.values.map((value: any) => value.secAbsVarianceAfterAdj)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const totalTarget = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return totaVariance ? totalTarget ? (totaVariance * 100) / totalTarget : 100 : 0;
                }
            },
            'secAbsVariance': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secCurPercntVal = params.values.map((value: any) => value.secCurPercntVal)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return secCurPercntVal - secModelTargetPercnt;
                }
            },
            'secAbsVarianceAfterAdj': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secPercntValAfterAdj = params.values.map((value: any) => value.secPercntValAfterAdj)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return secPercntValAfterAdj - secModelTargetPercnt;
                }
            },
            'secDolrVariance': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secMktVal = params.values.map((value: any) => value.secMktVal)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const mktValAfterAdj = params.values.map((value: any) => value.mktValAfterAdj).shift();
                return secMktVal - ((secModelTargetPercnt / 100) * mktValAfterAdj);
                }
            },
            'secDolrVarianceAfterAdj': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secMktValAfterAdj = params.values.map((value: any) => value.secMktValAfterAdj)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const mktValAfterAdj = params.values.map((value: any) => value.mktValAfterAdj).shift();
                return secMktValAfterAdj - ((secModelTargetPercnt / 100) * mktValAfterAdj);
                }
            },
            'rangeCellAggFunc': (params: IAggFuncParams) => {
                if(this.pralloc.group === 'ungroupedAllocLabel' && params.values.length > 0 && params.values[0]) {
                    const d: IPortfolioResultModelHistory = parent.data.modelHistoryList.find((x: IPortfolioResultModelHistory) => x.securitySymbol === params.values[0].parentSecSymb);
                    
                    if(d) {
                        const aggSecCurPercntVal = params.values.reduce((acc: number, val: any) => acc + val.secCurPercntVal, 0);
                        
                        return {
                            inRange: (aggSecCurPercntVal <= d.maximumPercentage && aggSecCurPercntVal >= d.minimumPercentage),
                            aboveRange: aggSecCurPercntVal > d.maximumPercentage
                        };
                    }
                } else if(params.values.length > 0 && params.values[0]) {
                    const totalCount = params.values.length;
                    const inRangeCountBefore = params.values.map((value: any) => value.isWithinRangeBefore ? 1 : 0)
                    .reduce((acc: number, val: number) => acc + val, 0);
                    return inRangeCountBefore < totalCount ? 0 - totalCount + inRangeCountBefore : totalCount;
                }
            },
            'rangeCellAggFuncAfterAdj': (params: IAggFuncParams) => {
                if(this.pralloc.group === 'ungroupedAllocLabel' && params.values.length > 0 && params.values[0]) {
                    const d: IPortfolioResultModelHistory = parent.data.modelHistoryList.find((x: IPortfolioResultModelHistory) => x.securitySymbol === params.values[0].parentSecSymb);
                    
                    if(d) {
                        const aggSecPercntValAfterAdj = params.values.reduce((acc: number, val: any) => acc + val.secPercntValAfterAdj, 0);
                        
                        return {
                            inRange: (aggSecPercntValAfterAdj <= d.maximumPercentage && aggSecPercntValAfterAdj >= d.minimumPercentage),
                            aboveRange: aggSecPercntValAfterAdj > d.maximumPercentage
                        };
                    }
                } else if(params.values.length > 0 && params.values[0]) {
                    const totalCount = params.values.length;
                    const inRangeCountAfter = params.values.map((value: any) => value.isWithinRangeAfter ? 1 : 0)
                    .reduce((acc: number, val: number) => acc + val, 0);
                    return inRangeCountAfter < totalCount ? 0 - totalCount + inRangeCountAfter : totalCount;
                }
            }
        };
    }

    getAutoGroupColumnDef(parent: ComPrAllocationsLegacyComponent): ColDef {
        const b: any = {
            headerName: 'Allocation',
            field: "secSymb",
            flex: 1,
            suppressMovable: true,
            cellRendererParams: {
                getTemplate: (params: any) => parent.getAllocationDescription(params),
                calltoactionUsesHover: true,
                calltoactionMaxWidth: 'none',
                calltoactionHorizontalOffset: 20,
                valueFormatter: (params: any) => {
                    if (params.data) {
                        if (params.data.secExclusionType) {
                            return "* " + params.value;
                        } else if (params.data.isEquivalentChild && params.data.countParent > 1) {
                            return params.value + " (Split)";
                        }
                    }
                    return params.value;
                },
                calltoactionclass: (params: any) => {
                    if (params.data && params.data.secType === 'GROUP' && params.data.rebalCompSecurityDTOList) {
                        return 'link-to-click';
                    }
                    return 'no-link-class'
                },
                calltoactionClick: (params: any) => {
                    parent.showGroupComponents(params);
                },
                showWarnIcon: (_params: any) => this.pralloc.group === 'ungroupedAllocLabel' && _params.data?.secType != 'UI_GROUP' && this.pras.getSecurityTradeActionNote(parent.data, _params.data?.secSymb).length > 0,
                getWarnIconTemplate: (_params: any) => parent.getSecurityTradeActionNoteTemplate(this.pras.getSecurityTradeActionNote(parent.data, _params.data?.secSymb))     
            }
        };

        if(this.pralloc.group === 'ungroupedAllocLabel') {
            b.headerComponentParams = {
                irbColInfo: `A warning icon in this column means that allocation has information to review. Select the View Explanations button for more.`
            };
        }

        if(this.pralloc.group === 'ungroupedAllocLabel' && !this.pralloc.showEquivalents) {
            b.cellRenderer = 'CallToActionCellComponent';
            b.cellRendererParams.calltoactionHorizontalOffset = -20;            
        } else {
            b.showRowGroup = true;
            b.cellRenderer = 'agGroupCellRenderer';
            b.cellRendererParams.calltoactionHorizontalOffset =20;
            b.cellRendererParams.innerRenderer = 'CallToActionCellComponent';
        }        

        return b;
    }

    getColumnDefs(parent: ComPrAllocationsLegacyComponent) {
        return [
            {
                headerName: "",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        suppressMovable: true,
                        colId: 'SEC_TYPE',
                        field: 'secType',
                        hide: true,
                        rowGroup: this.pralloc.group === 'SecCustTypeAllocLabel'
                    },
                    {
                        suppressMovable: true,
                        colId: 'SEC_CATEGORY',
                        field: 'secCatagory',
                        hide: true,
                        rowGroup: this.pralloc.group === 'SecCustCatAllocLabel'
                    },
                    {
                        suppressMovable: true,
                        colId: 'SEC_EQUIVALENT',
                        field: 'parentSecSymb',
                        hide: true,
                        rowGroup: this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents
                    },
                    {
                        ...this.getAutoGroupColumnDef(parent),
                        colId: 'ALLOCATION',
                        hide: this.pralloc.group !== 'ungroupedAllocLabel' || this.pralloc.showEquivalents,
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : ''
                    },
                    {
                        headerName: "Target %",
                        suppressMovable: true,
                        field: "secModelTargetPercnt",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secModelTargetPercnt', params.data),
                            isBlank: params.node.rowPinned && params.value === undefined
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        hide: !(parent.columnMode === 'secRelVariance' || parent.columnMode === 'secAbsVariance'),
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Target $",
                        suppressMovable: true,
                        field: "secModelTargetDollar",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '$',
                            decimalPosition: '2',
                            isDoubleDash: this.isValueDisplaySuppressed('secModelTargetDollar', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        hide: parent.columnMode !== 'secDolrVariance',
                        aggFunc: 'sum'
                    }
                ]
            },
            {
                headerGroupComponent: "RangeHeaderComponent",
                headerGroupComponentParams: {
                    title: "Allocations in range:",
                    count: () => parent.getInRangeCount("isWithinRangeBefore")
                },
                headerClass: () => (parent.isAllInRange("isWithinRangeBefore")) ? "in-range" : "out-of-range",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        headerName: "Value $",
                        suppressMovable: true,
                        field: "secMktVal",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            type: 'currency',
                            decimalPosition: '2'
                        },
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Actual %",
                        suppressMovable: true,
                        field: "secCurPercntVal",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secCurPercntVal', params.data),
                            isBlank: params.node.rowPinned && params.value === undefined
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Variance %",
                        suppressMovable: true,
                        field: "secRelVariance",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secAbsVariance: params.data.secAbsVariance,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secRelVariance,
                                    toString: () => params.data.secRelVariance
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secRelVariance', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'secRelVariance',
                        hide: parent.columnMode !== 'secRelVariance'
                    },
                    {
                        headerName: "Variance %",
                        suppressMovable: true,
                        field: "secAbsVariance",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secCurPercntVal: params.data.secCurPercntVal,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secAbsVariance,
                                    toString: () => params.data.secAbsVariance
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secAbsVariance', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'secAbsVariance',
                        hide: parent.columnMode !== 'secAbsVariance'
                    },
                    {
                        headerName: "Variance $",
                        suppressMovable: true,
                        field: "secDolrVariance",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secMktVal: params.data.secMktVal,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    mktValAfterAdj: params.data.portfolioMktValueAfterAdj,
                                    fieldValue: params.data.secDolrVariance,
                                    toString: () => params.data.secDolrVariance
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '$',
                            decimalPosition: '2',
                            isDoubleDash: this.isValueDisplaySuppressed('secDolrVariance', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'secDolrVariance',
                        hide: parent.columnMode !== 'secDolrVariance'
                    },
                    {
                        headerName: "",
                        sortable: false,
                        suppressMovable: true,
                        valueGetter: (params: ValueGetterParams): any => {
                            if (!params.node.group && !params.node.rowPinned) {
                                return {
                                    isWithinRangeBefore: params.data.isWithinRangeBefore,
                                    secCurPercntVal: params.data.secCurPercntVal,
                                    parentSecSymb: params.data.parentSecSymb
                                }
                            }
                        },
                        cellClass: (params: any) => {
                            if (params.node.rowPinned) {
                                return 'footer';
                            }                            
                            if (!params.data && params.value < 0 && this.pralloc.group !== 'ungroupedAllocLabel') {
                                return "out-of-range";
                            }
                        },
                        cellRenderer: 'RangeCellComponent',
                        cellRendererParams: (params: ICellRendererParams) => {
                            if(params.data) {
                                return {
                                    inRange: params.data.isWithinRangeBefore,
                                    aboveRange: params.data.isAboveRangeBefore,
                                    excluded: !!(params.data.secExclusionType || (this.showEquivalents()
                                        && (params.data.isEquivalentChild || params.data.isEquivalentParent)))
                                }
                            } else if(this.pralloc.group === 'ungroupedAllocLabel' && params.value) {
                                return {
                                    inRange: params.value.inRange,
                                    aboveRange: params.value.aboveRange,
                                    showIcon: true
                                }
                            } else {
                                return {
                                    absoluteValue: true,
                                    inRange: params.value >= 0,
                                    showIcon: params.value >= 0
                                }
                            }
                        },
                        minWidth: 25,
                        maxWidth: 25,
                        width: 25,
                        aggFunc: 'rangeCellAggFunc'
                    }
                ]
            },
            {
                headerName: "Adjustment",
                headerClass: "adjustment",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        headerName: "Position Adjustment",
                        suppressMovable: true,
                        field: "secAdjAmt",
                        flex: 1,
                        headerClass: "adjustment",
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            decimalPosition: '2',
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? ['adjustment', 'footer'] : 'adjustment',
                        aggFunc: 'sum'
                    }
                ]
            },
            {
                headerGroupComponent: "RangeHeaderComponent",
                headerGroupComponentParams: {
                    title: "Allocations in range:",
                    count: () => parent.getInRangeCount("isWithinRangeAfter")
                },
                headerClass: () => (parent.isAllInRange("isWithinRangeAfter")) ? "in-range" : "out-of-range",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        headerName: "Value $",
                        suppressMovable: true,
                        field: "secMktValAfterAdj",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            type: 'currency',
                            decimalPosition: '2'
                        },
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Actual %",
                        suppressMovable: true,
                        field: "secPercntValAfterAdj",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secPercntValAfterAdj', params.data),
                            isBlank: params.node.rowPinned && params.value === undefined
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Variance %",
                        suppressMovable: true,
                        field: "secRelVarianceAfterAdj",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secAbsVarianceAfterAdj: params.data.secAbsVarianceAfterAdj,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secRelVarianceAfterAdj,
                                    toString: () => params.data.secRelVarianceAfterAdj
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secRelVarianceAfterAdj', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'secRelVarianceAfterAdj',
                        hide: parent.columnMode !== 'secRelVariance'
                    },
                    {
                        headerName: "Variance %",
                        suppressMovable: true,
                        field: "secAbsVarianceAfterAdj",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secPercntValAfterAdj: params.data.secPercntValAfterAdj,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secAbsVarianceAfterAdj,
                                    toString: () => params.data.secAbsVarianceAfterAdj
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secAbsVarianceAfterAdj', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'secAbsVarianceAfterAdj',
                        hide: parent.columnMode !== 'secAbsVariance'
                    },
                    {
                        headerName: "Variance $",
                        suppressMovable: true,
                        field: "secDolrVarianceAfterAdj",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secMktValAfterAdj: params.data.secMktValAfterAdj,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    mktValAfterAdj: params.data.portfolioMktValueAfterAdj,
                                    fieldValue: params.data.secDolrVarianceAfterAdj,
                                    toString: () => params.data.secDolrVarianceAfterAdj
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '$',
                            decimalPosition: '2',
                            isDoubleDash: this.isValueDisplaySuppressed('secDolrVarianceAfterAdj', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? 'footer' : '',
                        aggFunc: 'secDolrVarianceAfterAdj',
                        hide: parent.columnMode !== 'secDolrVariance'
                    },
                    {
                        headerName: "",
                        sortable: false,
                        suppressMovable: true,
                        valueGetter: (params: ValueGetterParams): any => {
                            if (!params.node.group && !params.node.rowPinned) {
                                return {
                                    isWithinRangeAfter: params.data.isWithinRangeAfter,
                                    secPercntValAfterAdj: params.data.secPercntValAfterAdj,
                                    parentSecSymb: params.data.parentSecSymb
                                }
                            }
                        },
                        cellClass: (params: any) => {
                            if (params.node.rowPinned) {
                                return 'footer';
                            }                            
                            if (!params.data && params.value < 0 && this.pralloc.group !== 'ungroupedAllocLabel') {
                                return "out-of-range";
                            }
                        },
                        cellRenderer: 'RangeCellComponent',
                        cellRendererParams: (params: ICellRendererParams) => {
                            if(params.data) {
                                return {
                                    inRange: params.data.isWithinRangeAfter,
                                    aboveRange: params.data.isAboveRangeAfter,
                                    excluded: !!(params.data.secExclusionType || (this.showEquivalents()
                                        && (params.data.isEquivalentChild || params.data.isEquivalentParent)))
                                }
                            } else if(this.pralloc.group === 'ungroupedAllocLabel' && params.value) {   
                                return {
                                    inRange: params.value.inRange,
                                    aboveRange: params.value.aboveRange,
                                    showIcon: true
                                }
                            } else {
                                return {
                                    absoluteValue: true,
                                    inRange: params.value >= 0,
                                    showIcon: params.value >= 0
                                }
                            }
                        },
                        minWidth: 25,
                        maxWidth: 25,
                        width: 25,
                        aggFunc: 'rangeCellAggFuncAfterAdj'
                    }
                ]
            }
        ];
    }

    isValueDisplaySuppressed(field: string, data: any): boolean {
        switch (field) {
            case 'secModelTargetPercnt':
            case 'secModelTargetDollar':
            case 'secDolrVariance':
            case 'secDolrVarianceAfterAdj':
                return (data && (data.isEquivalentChild || data.isEquivalentParent)) && this.showEquivalents();
            case 'secCurPercntVal':
            case 'secPercntValAfterAdj':
                return !!(data && data.secExclusionType);
            case 'secRelVariance':
            case 'secAbsVariance':
            case 'secRelVarianceAfterAdj':
            case 'secAbsVarianceAfterAdj':
                return !!(data && (data.secExclusionType || ((data.isEquivalentChild || data.isEquivalentParent)
                    && this.showEquivalents())));
            default:
                return false;
        }
    }

    private showEquivalents(): boolean {
        return this.pralloc.showEquivalents && this.pralloc.group === 'ungroupedAllocLabel';
    }
}
